import React from 'react';
import MaterialTable from 'material-table';

const BlankTable = ({ title, columns, data, style, actions, options, localization, components }) => {
    return (
        <MaterialTable
            title={title}
            columns={columns}
            data={data}
            style={style}
            actions={actions}
            options={{ ...options,}}
            localization={localization}
            components={components}
        />

    )
}

export default BlankTable;